import * as React from "react";
import { Card } from "@grandvisionhq/common";
import { Button } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
import { LoyaltyCardType } from "../../../../types.js";
import { LoyaltyPoint } from "../../../LoyaltyPoint/components/LoyaltyPoint/LoyaltyPoint.js";
/* empty css                               */
const LoyaltyPointsOverviewCard = ({
  labels,
  loyaltyDetails,
  onEdit,
  onAdd,
  className
}) => {
  const getLoyaltyNumberText = (type) => {
    return type === LoyaltyCardType.LUHN ? `${labels.number}: ${loyaltyDetails.cardNumber || labels.enterNumber}` : labels.autoAdded;
  };
  return /* @__PURE__ */ React.createElement(Card, { "data-t": "loyalty-points-overview-card", className }, /* @__PURE__ */ React.createElement(Card.Content, null, loyaltyDetails.type == LoyaltyCardType.LUHN && onEdit && loyaltyDetails.cardNumber && /* @__PURE__ */ React.createElement(Card.Actions, null, /* @__PURE__ */ React.createElement(Card.Button, { onClick: onEdit, children: labels.edit })), /* @__PURE__ */ React.createElement(Card.Text, { variant: "body-head", className: "loyalty-points-overview-card--caption" }, labels.heading), /* @__PURE__ */ React.createElement(Card.Text, { color: "text-secondary", variant: "caption" }, labels.collected, ":"), /* @__PURE__ */ React.createElement(LoyaltyPoint, { loyaltySymbol: labels.loyaltySymbol, points: loyaltyDetails.points }), loyaltyDetails.cardNumber && loyaltyDetails.type ? /* @__PURE__ */ React.createElement(Card.Text, { variant: "caption" }, getLoyaltyNumberText(loyaltyDetails.type)) : /* @__PURE__ */ React.createElement(
    Button,
    {
      onClick: onAdd,
      variant: "ghost",
      className: "loyalty-points-overview-card__add-button"
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "plus" }),
    labels.addCard
  )));
};
export {
  LoyaltyPointsOverviewCard
};
//# sourceMappingURL=LoyaltyPointsOverviewCard.js.map
